<template>
  <div>
    <div class="card menu-bg-blue-transparent dll-container" :class="{ 'card--minimized': isMinimized }">
      <!-- Data panel header -->
      <div class="data-panel">
        <fa
          :icon="['fas', isMinimized ? 'caret-up' : 'caret-down']"
          class="data-panel__minimize cursor"
          :title="isMinimized ? 'Expand layer list' : 'Minimize layer list'"
          @click="toggleMinimize"
        />
        <b-row no-gutters class="mb-2">
          <b-col cols="12">
            <button class="change-region-btn" title="Change Dataset" @click="$bvModal.show('datasetSelection')">
              <svg class="change-region-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="8" cy="8" r="6.5" stroke="currentColor" stroke-width="1.2"/>
                <path d="M8 1.5C8 1.5 10.5 4 10.5 8S8 14.5 8 14.5M8 1.5C8 1.5 5.5 4 5.5 8S8 14.5 8 14.5M1.5 8h13" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
              </svg>
              <span>Change Dataset</span>
            </button>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="layer-list-font">
            {{ (customerName ? customerName.substring(0, customerName.length - 3) : '') + 'Delivery Review Tool' }}
          </b-col>
        </b-row>
        <b-row v-if="dataset">
          <b-col class="layer-list-font">{{ getFormattedDate(dataset.releaseDate) + ' - ' + dataset.extent }}</b-col>
        </b-row>
        <b-row v-if="dataset">
          <b-col class="layer-list-font">{{ dataset.partNumber }}</b-col>
        </b-row>
      </div>

      <div class="card-body-padding" v-show="!isMinimized">
        <div class="scroll-Container">
          <MMP_DLL
            class="panel-height"
            :customerProjectId="customerProjectId"
            :drtLayersButtonsCtrl="drtLayersButtonsCtrl"
            :drtLayersToggle="drtLayersToggle"
            :filterClassesObj="filterClassesObj"
            :layerResponse="layerResponse"
            :map="map"
            :mmp_layersObj="mmp_layersObj"
            :otonomoSubcountry="otonomoSubcountry"
            :rules="rules"
            :selectAllControl="selectAllControl"
            :showDRTLayers="showDRTLayers"
            :spinnerManager="spinnerManager"
            :zoomEnded="zoomEnded"
            :zoomLevelCap="zoomLevelCap"
            :showLidarPanel="showLidarPanel"
            :baseMapsOpen="baseMapsOpen"
            :extentsOpen="extentsOpen"
            :user="user"
            @removeLayerListener="$emit('removeLayerListener')"
            @getErrorsLayer="$emit('getErrorsLayer', $event)"
            @getFilterModal="getFilterModal($event.layer, $event.id)"
            @getLegend="$emit('getLegend', $event)"
            @getShowAttributes="$emit('getShowAttributes', $event)"
            @layerButtonsChanged="$emit('layerButtonsChanged', $event)"
            @loadAttributes="$emit('loadAttributes', $event)"
            @toggleErrorsLayerVisibility="$emit('toggleErrorsLayerVisibility')"
            @toggleLayers="toggleDRTLayers()"
            @toggleLayerVisibility="$emit('toggleLayerVisibility', $event)"
            @toTopOfList="$emit('toTopOfList', $event)"
            @updateZoomEnded="$emit('updateZoomEnded', $event)"
          ></MMP_DLL>
        </div>

        <MMP_LayerFilterModal
          :filter_layer="filter_layer"
          :generateCQLObj="generateCQLObj"
          :isErrorsLayer="isErrorsLayer"
          :layerProperties="layerProperties"
          :map="map"
          :mmp_layersObj="mmp_layersObj"
          :selectedElement="selectedElement"
          :user="user"
          :zoomLevelCap="zoomLevelCap"
          :selectedExtent="selectedExtent"
          @filterClassesObjChanged="filterClassesObj = $event"
          @rulesChanged="rules = $event"
        ></MMP_LayerFilterModal>
      </div>
    </div>
  </div>
</template>

<style scoped>
.dll-container {
  background-color: transparent !important;
  width: 20rem;
}
.card {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 20px);
  overflow: hidden;
  overflow-x: hidden;
  position: relative;
  border: none;
}
/* When minimized, collapse the card to the header height so the empty
   area below no longer overlays (and blocks clicks on) the map. */
.card--minimized {
  height: auto;
}
.card-body-padding {
  flex: 1;
  min-height: 0;
  /* overflow: hidden; */
  display: flex;
  flex-direction: column;
  /* padding-top: 0.5rem; */
}
.card-body-padding > div {
  flex: 1;
  min-height: 0;
  /* overflow: hidden; */
  display: flex;
  flex-direction: column;
}
.scroll-Container {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

/* ── Data panel header ── */
.data-panel {
  width: 100%;
  background-color: #063c6d;
  color: white;
  padding: 5%;
  position: relative;
}
.data-panel__minimize {
   position: absolute;
    bottom: 8%;
    right: 6%;
    font-size: 22px;
    color: #ffffff;
    cursor: pointer;
    z-index: 2;
}
.data-panel__minimize:hover {
  opacity: 0.7;
}
.layer-list-font {
  font-size: 13px !important;
  font-weight: 500;
}
.change-region-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  background: linear-gradient(135deg, rgba(32, 255, 155, 0.18) 0%, rgba(4, 150, 233, 0.15) 100%);
  border: 1.5px solid rgba(32, 255, 155, 0.6);
  border-radius: 8px;
  color: #20ff9b;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 5px 10px;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  box-shadow: 0 0 10px rgba(32, 255, 155, 0.2), inset 0 1px 0 rgba(255,255,255,0.08);
  transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;
}
.change-region-btn:hover {
  background: linear-gradient(135deg, rgba(32, 255, 155, 0.32) 0%, rgba(4, 150, 233, 0.25) 100%);
  border-color: #20ff9b;
  box-shadow: 0 0 18px rgba(32, 255, 155, 0.45), 0 2px 8px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.1);
  transform: translateY(-1px);
  color: #fff;
  text-shadow: 0 0 8px rgba(32, 255, 155, 0.8);
}
.change-region-btn:active {
  transform: translateY(0);
  box-shadow: 0 0 6px rgba(32, 255, 155, 0.25);
}
.change-region-icon {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

/* ── Scrollbar ── */
.scroll-Container::-webkit-scrollbar {
  width: 5px;
}
.scroll-Container::-webkit-scrollbar-track {
  background-color: transparent !important;
  box-shadow: none !important;
}
.scroll-Container::-webkit-scrollbar-thumb {
  background-color: transparent !important;
  border-radius: 999px;
}
.card:hover .scroll-Container::-webkit-scrollbar-track {
  background-color: rgba(6, 60, 109, 0.06) !important;
  border-radius: 999px;
}
.card:hover .scroll-Container::-webkit-scrollbar-thumb {
  background-color: rgba(6, 60, 109, 0.25) !important;
}
.card:hover .scroll-Container::-webkit-scrollbar-thumb:hover {
  background-color: rgba(6, 60, 109, 0.5) !important;
}
</style>

<script>
import axios from 'axios'
import draggable from 'vuedraggable'
import MMP_DLL from './../shared/MMP_DLL.vue'
import MMP_LayerFilterModal from './../shared/MMP_LayerFilterModal.vue'
export default {
  name: 'MMP_DRT_Layers',
  components: {
    draggable,
    MMP_DLL,
    MMP_LayerFilterModal
  },
  props: [
    'customerName',
    'customerProjectId',
    'dataset',
    'drtLayersButtonsCtrl',
    'layersListMaxHeight',
    'layerResponse',
    'map',
    'mmp_layersObj',
    'olSelectkey',
    'otonomoSubcountry',
    'persistingLayerFilters',
    'selectedExtent',
    'spinnerManager',
    'showDRTLayers',
    'user',
    'zoomEnded',
    'zoomLevelCap',
    'showLidarPanel',
    'baseMapsOpen',
    'extentsOpen'
  ],
  data() {
    return {
      app: 'drt',
      drtLayersToggle: true,
      extentRecentlyChanged: true,
      filterClassesObj: null,
      filter_layer: null,
      filter_operator: null,
      filter_property: null,
      filter_value: null,
      filter_value_2: null,
      generateCQLObj: null,
      isErrorsLayer: false,
      isHidden: true,
      layerButtons: null,
      layerProperties: [],
      maintainView: false,
      maintainViewArr: [],
      operators: [
        {id: 1, tag: '<'},
        {id: 2, tag: '>'},
        {id: 3, tag: '='},
        {id: 4, tag: '<>'},
        {id: 5, tag: '<='},
        {id: 6, tag: '>='},
        {id: 7, tag: 'BETWEEN'}
      ],
      rules: [],
      selectedElement: null,
      selectAllControl: false,
      showLayers: false,
      isMinimized: false
    }
  },
  methods: {
    toggleMinimize() {
      this.isMinimized = !this.isMinimized
    },
    getReleases(id) {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/release/project/' + id, {
            method: 'GET',
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (!content.errors) {
              if (this.user.role == 'Generic User') {
                // Changing dataset names for generic users
                for (let i = 0; i < content.length; i++) {
                  content[i].notes = 'Sample dataset-' + parseInt(i + 1)
                }
              }
              this.$emit('getReleases', content)
              this.release_id = content[0].id
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },
    checkLayer(layer) {
      // Checks if layer exists on the map
      let exists = false
      let mapLayersArr = this.map.getLayers().getArray()

      switch (typeof layer) {
        case 'object':
          for (let i in mapLayersArr) {
            // If layer exists, return true
            exists = mapLayersArr[i] === layer
            if (exists) {
              break
            }
          }
          break
        case 'string':
          for (let i in mapLayersArr) {
            // If layer exists, return true
            exists =
              mapLayersArr[i].values_.hasOwnProperty('name') &&
              mapLayersArr[i].values_.name === layer
            if (exists) {
              break
            }
          }
          break
      }

      return exists
    },
    getFilterModal(layer, id) {
      this.isErrorsLayer = (layer == 'errors') ? true : false 
      this.selectedElement = id
      this.filter_layer = layer
      /* This function clears all previous selections of rules and calls
      a function for getting filter properties based on layer selection */
      this.getFilterProperties()
      this.$bvModal.show('filterModal')
    },
    getCQLDateFilterString(prop, op, val, val2 = null) {
      /* Creates Date object with inputted value, converts the date to
      an ISO-formatted string, then removes unneeded data from the end
      of the string. */
      let date = this.getISOSubstring(val)
      let newDateMillis = 0
      let dayInMillis = 86400000
      let fourHourInMillis = 14400000
      let currentLayer = prop + ` `

      switch (op) {
        case '=':
          newDateMillis =
            this.getTimeInMillis(date) + dayInMillis - fourHourInMillis - 1
          currentLayer +=
            `DURING ` + date + ` / ` + this.getISOSubstring(newDateMillis)
          break
        case '>':
          newDateMillis = this.getTimeInMillis(date) - fourHourInMillis
          currentLayer += `AFTER ` + this.getISOSubstring(newDateMillis)
          break
        case '>=':
          newDateMillis = this.getTimeInMillis(date) - fourHourInMillis
          currentLayer += `AFTER ` + this.getISOSubstring(newDateMillis)
          break
        case '<':
          newDateMillis = this.getTimeInMillis(date) - fourHourInMillis
          currentLayer += `BEFORE ` + this.getISOSubstring(newDateMillis)
          break
        case '<=':
          newDateMillis = this.getTimeInMillis(date) - fourHourInMillis
          currentLayer += `BEFORE ` + this.getISOSubstring(newDateMillis)
          break
        case 'BETWEEN':
          let secondDate = this.getISOSubstring(val2)
          // Subtract an extra millisecond to avoid data from wrong date
          newDateMillis =
            this.getTimeInMillis(secondDate) +
            dayInMillis -
            fourHourInMillis -
            1
          currentLayer +=
            `DURING ` + date + ` / ` + this.getISOSubstring(newDateMillis)
          break
      }

      return currentLayer
    },
    getISOSubstring(date) {
      return new Date(date).toISOString().substring(0, 19) + `-04:00`
    },
    getTimeInMillis(date) {
      // Converts date from ISO formatted string to milliseconds
      return new Date(date).getTime()
    },
    toggleDRTLayers() {
      this.drtLayersToggle = !this.drtLayersToggle
    },
    getFilterProperties() {
      /* This function gets the current layer name and finds the source and store
      name of the layer. The url generated is completely dynamic and used for all
      customers. Describe feature gets the feature types from the geoserver layer. */
      let mmpLayer = this.mmp_layersObj[this.filter_layer]
      let layerType = mmpLayer.layer.getSource().params_.LAYERS
      let lastItem = layerType.split(':')[0]
      let url = mmpLayer.geoserverName.split('?')[0] + '?'

      // Geoserver Web Feature Service
      if (sessionStorage.token) {
        axios
          .get(url, {
            params: {
              service: 'WFS',
              version: '1.1.0',
              request: 'DescribeFeatureType',
              typename: layerType,
              name: this.filter_layer,
              wsName: lastItem,
              srsname: 'EPSG:4326',
              outputFormat: 'application/json',
              INFO_FORMAT: 'application/json',
              authkey: sessionStorage.token
            }
          })
          .then(response => {
            let tempProps = []
            response.data.featureTypes[0].properties.forEach(item => {
              tempProps.push({name: item.name})
            })
            this.layerProperties = tempProps
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },
    getFormattedDate(originalDateString) {
      let originalDateObj = new Date(originalDateString)
      let returnValue = originalDateObj
        .toLocaleString('en-US', {
          dateStyle: 'short'
        })
        .replace(/\//g, '.')
      return returnValue
    }
  },
  mounted() {
    this.getReleases(this.customerProjectId)
    if (this.rules == []) {
      this.rules = this.persistingLayerFilters
    }
    this.layerButtons = this.drtLayersButtonsCtrl
    this.$emit('DLLChange')
  },
  updated() {
    this.$emit('DLLChange')
  },
  watch: {
    drtLayersButtonsCtrl: function (newValue, oldValue) {
      this.layerButtons = newValue
      let layerButtonsLoaded = newValue.length == this.layerResponse.length
      // Checks to see if drtLayersButtonsCtrl has finished being updated
      if (layerButtonsLoaded && !this.extentRecentlyChanged) {
        this.rules = this.persistingLayerFilters
        this.rules.forEach(rule => {
          /* Changing generateCQLObj will trigger a watch in MMP_LayerFilterModal.vue
          to refresh the CQL filter for this rule when the dynamic layer list is reordered */
          this.generateCQLObj = {
            layer: rule.layer,
            enableZoom: false
          }
        })
      } else if (layerButtonsLoaded) {
        // This is necessary for when the dataset is swapped to a new extent
        this.extentRecentlyChanged = false
      }
    },
    rules: function (newValue, oldValue) {
      /*
      REFACTORED: array obj comparison error
        originally had: oldValue != []
        now: oldValue.length != 0
        reason: [] != [] => true - javascript will return true if they are two different objects, which is the case
      */
      if (oldValue.length != 0) {
        this.$emit('rulesChanged', newValue)
      }
    },
    selectedExtent: function (newValue, oldValue) {
      this.extentRecentlyChanged = true
    }
  }
}
</script>
